<template>
  <div>
    <div class="play-list">
      <div class="container">
        <div class="main-cont">
          <div class="row">
            <div class="col-md-6 all">
              <div class="cont">
                <div class="header">
                  <h3>My Playlists</h3>
                  <a href="#">
                    <img class="svg" src="@/assets/dashboard/svg/playlist/1.svg" alt="">
                  </a>
                  <a href="#">
                    <img class="svg" src="@/assets/dashboard/svg/playlist/2.svg" alt="">
                  </a>
                </div>
                <ul class="list-group">
                  <li class="list-group-item" v-for="playlist in user.playlists" :key="playlist.id">
                    <div class="desc">
                      <h4>{{ playlist.name }}</h4>
                      <p>Created By {{ user.firstName }}</p>
                    </div>

                  </li>
                </ul>
                <a href="#" class="add" data-bs-toggle="modal" data-bs-target="#addNewPlaylist">
                  + Add New Playlist
                </a>

              </div>
            </div>
            <div class="col-md-6 all">
              <div class="cont">
                <div class="header">
                  <h3>My Team Rooms</h3>
                  <a href="#">
                    <img class="svg-two" src="@/assets/dashboard/svg/playlist/3.svg" alt="">
                  </a>
                </div>
                <ul class="list-group" v-for="room in user.rooms" :key="room.id">
                  <li class="list-group-item">
                    <div class="desc">
                      <h4>{{ room.name }}</h4>
                      <p>00 Members</p>
                    </div>
                    <div class="butt">
                      <a :href="'https://uaeafter2pm.org/en/forum/CUSTOM/'+room.id" target="_blank">
                        <img class="svg-inside" src="@/assets/dashboard/svg/playlist/4.svg" alt="">
                      </a>
                      <a :href="'https://uaeafter2pm.org/en/forum/CUSTOM/'+room.id" target="_blank">
                        <img class="svg-inside" src="@/assets/dashboard/svg/playlist/5.svg" alt="">
                      </a>
                    </div>
                  </li>
                </ul>
                <div v-if="user.rooms && user.rooms.length === 0">
                  <br><br><br>
                </div>
                <a href="#" class="add" data-bs-toggle="modal" data-bs-target="#addNewRoom">
                  + Add New Team Room
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="addNewPlaylist" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Add New Playlist</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <PlaylistForm/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="addNewRoom" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="exampleModalLabel">Add New Room</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <RoomForm/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlaylistForm from "@/components/forms/PlaylistForm";
import RoomForm from "@/components/forms/RoomForm";

export default {
  components: {RoomForm, PlaylistForm},
  computed: {
    user() {
      return this.$store.getters["auth/userData"];
    },
  }
}
</script>

<style lang="scss">
.svg {
  width: 30px;
  height: 30px;
}
.svg-two {
  width: 49px;
  height: 49px;
}
.svg-inside {
  width: 22px;
  height: 22px;
}
.play-list {
  padding: 206px 0 186px 0;
  background: #003827;
  .main-cont {
    padding: 0 40px;
    .all {
      .cont {
        background: rgba(5, 5, 5, 0.3);
        border-radius: 17px;
        padding: 40px 38px 29px 38px;
        .header {
          h3 {
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 36px;
            line-height: 107.19%;
            text-align: justify;
            color: #FFFFFF;
            float: left;
          }
          a {
            float: right;
            margin-left: 14px;
            svg {
              width: 30px;
              height: 30px;
            }
          }
        }
        ul {
          margin-bottom: 20px;
          clear: both;
          li {
            background: linear-gradient(99.52deg, #00F07E -32.99%, #003827 120.45%);
            border-radius: 15px;
            margin: 10px 0;
            border: none;
            padding: 25px 32px;
            .desc {
              h4 {
                font-family: Roboto;
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 107.19%;
                text-align: justify;
                color: #FFFFFF;
              }
              p {
                font-family: Roboto;
                font-style: normal;
                font-weight: 300;
                font-size: 18px;
                line-height: 107.19%;
                text-align: justify;
                color: #FFFFFF;
              }
            }
          }
        }
        .add {
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 107.19%;
          text-align: justify;
          color: #FFFFFF;
          text-decoration: none;
        }
      }
    }
    .all:nth-of-type(2) {
      .cont {
        background: rgba(5, 5, 5, 0.7);
        .header {
          a {
            svg {
              width: 49px;
              height: 49px;
            }
          }
        }
        ul {
          li {
            background: linear-gradient(99.52deg, #FFFFFF -32.99%, #003827 120.45%);
            .desc {
              float: left;
              h4, p {
                color: #050505;
              }
            }
            .butt {
              float: right;
              a {
                margin-left: 14px;
                svg {
                  width: 22px;
                  height: 22px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
